export default {
  'en': { goal_sexual_wellness: 'Intimate Wellness' },
  'es': { goal_sexual_wellness: 'el Bienestar íntimo' },
  'es-mx': { goal_sexual_wellness: 'el Bienestar íntimo' },
  'pt': { goal_sexual_wellness: 'o Bem-estar íntimo' },
  'pt-br': { goal_sexual_wellness: 'o Bem-estar íntimo' },
  'de': { goal_sexual_wellness: 'Intimes Wohlbefinden' },
  'fr': { goal_sexual_wellness: 'ton Bien-être intime' },
  'it': { goal_sexual_wellness: 'il Benessere intimo' },
};
